import isArray from "lodash/isArray";

export default function requiresAtleastOneItem(items) {
    return isArray(items) && items.length > 0;
}